module.exports = __webpack_public_path__ + "static/media/gibson.e1362500.jpg";